<template>
  <div>
    <section v-if="competition.type === 'APPLICATION'">
      <b-row class="text-left">
        <b-col md="12">
          <div class="m-1 mt-3">
            <b-row>
              <b-col md="12">
                <p v-if="!fieldIsEmpty(competition.subsidy)">
                  <b>Támogatás mértéke:</b> {{ numberWithDots(competition.subsidy) }}
                </p>
                <p><b>Előminősítés:</b> {{ competition.preQualification ? 'Van' : 'Nincs' }}</p>
                <p v-if="competition.preQualification">
                  <b>Előminősítés kezdete:</b> {{ formatDate(competition.preQualificationStart) }}
                </p>
                <p v-if="competition.preQualification">
                  <b>Előminősítés vége:</b> {{ formatDate(competition.preQualificationEnd) }}
                </p>
                <pre>{{ competition.text }}</pre>
                <br />
                <b-row>
                  <b-col md="6" v-if="competition.preQualification">
                    <b-button class="interested-button" @click="handleOfferLink(competition.preQualificationLink)"
                      >Előminősítési link</b-button
                    >
                  </b-col>
                  <b-col md="6">
                    <b-button class="interested-button" @click="handleOfferLink(competition.link)">Érdekel</b-button>
                  </b-col>
                </b-row>
              </b-col>
              <b-col align="right" cols="2"> </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </section>
    <section v-if="competition.type === 'CREDIT'">
      <b-row class="text-left">
        <b-col>
          <b-row>
            <b-col md="12">
              <p v-if="!fieldIsEmpty(competition.creditLength)"><b>Futamidő:</b> {{ competition.creditLength }}</p>
              <p v-if="!fieldIsEmpty(competition.creditAmount)">
                <b>Hitelösszeg:</b> {{ numberWithDots(competition.creditAmount) }}
              </p>
              <p v-if="!fieldIsEmpty(competition.creditInterest)">
                <b>Kamat:</b> {{ numberWithDots(competition.creditInterest) }}
              </p>
              <pre>{{ competition.text }}</pre>
              <br />
              <b-row>
                <b-col md="6">
                  <b-button class="interested-button" @click="handleOfferLink(competition.link)">Érdekel</b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </section>
    <section v-if="competition.type === 'CAPITAL_PRODUCT'">
      <b-row class="text-left">
        <b-col>
          <b-row>
            <b-col md="12">
              <p v-if="!fieldIsEmpty(competition.capitalAmount)">
                <b>Finanszírozás összege:</b> {{ numberWithDots(competition.capitalAmount) }}
              </p>
              <p v-if="!fieldIsEmpty(competition.capitalInvestmentLength)">
                <b>Befektetés időtartama :</b> {{ competition.capitalInvestmentLength }}
              </p>
              <p v-if="!fieldIsEmpty(competition.capitalLength)">
                <b>Tőkealap futamideje:</b> {{ competition.capitalLength }}
              </p>
              <pre>{{ competition.text }}</pre>
              <br />
              <b-row>
                <b-col md="6">
                  <b-button class="interested-button" @click="handleOfferLink(competition.link)">Érdekel</b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </section>
    <section v-if="competition.type === 'GUARANTEE'">
      <b-row class="text-left">
        <b-col>
          <b-row>
            <b-col md="12">
              <p v-if="!fieldIsEmpty(competition.guaranteeCost)"><b>Éves díj:</b> {{ competition.guaranteeCost }}</p>
              <p v-if="!fieldIsEmpty(competition.guaranteeMax)">
                <b>Kezességvállalás maximuma:</b> {{ competition.guaranteeMax }}
              </p>
              <p v-if="!fieldIsEmpty(competition.guaranteeLength)">
                <b>Kezességvállalás futamideje:</b> {{ competition.guaranteeLength }}
              </p>
              <pre>{{ competition.text }}</pre>
              <br />
              <b-row>
                <b-col md="6">
                  <b-button class="interested-button" @click="handleOfferLink(competition.link)">Érdekel</b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </section>
  </div>
</template>
<script>
export default {
  name: 'CompetitionSmallDetails',
  props: ['competition'],
  methods: {
    numberWithDots(number) {
      if (!this.fieldIsEmpty(number)) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    },
    formatDate: function(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [year, month, day].join('.')
    },
    handleOfferLink(link) {
      const win = window.open(link, '_blank')
      win.focus()
    },
    fieldIsEmpty: function(field) {
      return field === '' || field === null || field === undefined
    }
  }
}
</script>
<style scoped>
pre {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  font-size: 16px;
  color: #6f6f6f;
  white-space: pre-wrap; /* Since CSS 2.1 */
  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
}
.interested-button {
  width: inherit;
}
</style>
